import MUILink from "@mui/material/Link";

const Link = MUILink;

export default Link;
